<template>
  <div class="s-intro" :class="{'clickclose':ishide}" v-if="playInfo">
    <div class="close iconfont icon-close-line" @click="hide"></div>
    <div class="intro-pic"  > <!---->
      <s-audio-ani :playInfo="playInfo" v-if="playInfo.media_path"></s-audio-ani>
      <van-image :src="showpath+playInfo.pic_list" fit="cover" @click="more"></van-image>
      <s-audio-line v-if="playInfo.media_path"></s-audio-line>
      <div class="clock-total" v-if="clockNum && config.clock">
        {{clockNum}}人已打卡
      </div>
    </div>
    <div class="intro-txt">
      <span class="title">{{playInfo.name}}</span>
      <div class="sub">
        <span>{{playInfo.introduce}}</span>
      </div>
      <div class="intro-fun" >
        <template v-if="playInfo.typeid==79 && config.clock">
          <div class="fun-item" @click="clock" v-if="!clockState ">
            <span>打卡</span>
          </div>
          <div class="fun-item active" v-else>
            <span>已打卡</span>
          </div>
        </template>
        <div class="fun-item" @click="daohang" v-if="playInfo.coordinatesec && config.navigator">
          <span>导航</span>
        </div>
        <!-- <div class="fun-item" @click="more">
          <span>更多</span>
          <span class="ico ico-right "></span>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import config from "@/config"
import playMixin from './playMixin';
import SAudioAni from '../s-audioAni.vue';
import SAudioLine from '../s-audioLine.vue';
import wx from "weixin-js-sdk"
export default {
  components: {  SAudioAni, SAudioLine },
  props: {id:Number|String,snum:Number|String },
  mixins:[playMixin],
  data(){
    return{
        config,
       playInfo:null,
       ishide: false,
       showpath:null,
       clockState:false,
       dataInfo:null,
       clockNum: null,
       openid:window.openid
    }
  },
  watch: {
      id: {
        handler(newv,oldv){
          if (newv) {
            this.getSpotById(newv);
            this.getSumCount(newv);
          }
        },
        immediate: true
    },
    snum: {
        handler(newv,oldv){
          if (newv>0) {
            if(!this.dataInfo) return;
            let audio_num = Number(newv)-1;
            let src = this.dataInfo.mp3list.find((res,i)=>{return i==audio_num});
            this.playInfo.name = src.name;
          }
        },
        immediate: true
    }
  },
  mounted() {
    
  },
methods:{
  async hide(){
   this.ishide = await true;
   let time=setTimeout(() => {
    this.$emit('hide')
    this.ishide = false;
    clearTimeout(time)
   }, 1000);
 },
  // hide(){
  //   this.$emit('hide')
  // },
  more(){
    let ids = [79,87]
    if(!ids.includes(this.playInfo.typeid)){return}
    this.$emit("show-detail",this.playInfo.id)
  },
  
  // 获取数据
  getSpotById(id){
    this.$api.mapApi.getSpotById(id).then(async data=>{
      if(data){
        let res = data.data;
        if(!this.showpath) this.showpath = data.showpath;
        let audio_num = this.snum?Number(this.snum)-1: 0;

        this.dataInfo = data;
        this.clockState = data.isclock==0?false:true
        let src;
        if(data.mp3list&&data.mp3list.length>0&&audio_num>=0) {
          src = data.mp3list.find((res,i)=>{return i== audio_num});
          res.src = data.showpath+src.media_path;//设置音频
          res.media_path = src.media_path;
          res.name = src.name;
        }else if(res.media_path) {
          res.src = data.showpath+res.media_path;//设置音频
        }
        res.pic_list = res.pic_list&&res.pic_list.split(',')[0];
        res.dura_tion = this.$utils.map.formData(res.duration);
        res.small = true;
        this.playInfo = res;
        


      }
    })
    
  },

  async clock(){
    await this.$api.clockApi.add({
        scenic_id: this.playInfo.id,
        scenic_name:this.playInfo.name,
        scenic_picture:this.playInfo.cover_img
    });
    this.clockState = true;
    // this.$toast.success("打卡成功")
    if(this.$parent.$refs.bigIntro){
      this.$parent.$refs.bigIntro.clocked = true
    }
    this.$emit("clock",this.playInfo.id)
  },
  // 获取打卡数量
  async getSumCount(id){
    let res = await this.$api.mapApi.getSumCount(id);
    if(res && res.code==0){
    this.clockNum = res.data;
    }else{
      this.$toast.fail(res.msg)
    }
  },

  daohang(){  
    if(!this.playInfo.coordinatesec) return
    if(!window.openid){
      this.$toast("当前登录环境不支持打开微信地图，请切换微信小程序环境"); return
    }
    try{
      wx.miniProgram.navigateTo({url: `/pages/map/map?id=${this.playInfo.id}&coord=${this.playInfo.coordinatesec}&name=${this.playInfo.name}&address=${this.playInfo.address +this.playInfo.name}`})
    }catch(err){}
    }
  },
  openMap(){
    let coordinate = this.playInfo.coordinatesec.split(",")
    let name  = this.playInfo.name
    let address = this.playInfo.address +this.playInfo.name
    wx.ready(function () {
      wx.openLocation({
        latitude: parseFloat(coordinate[1]), // 26.82  纬度，浮点数，范围为90 ~ -90
        longitude: parseFloat(coordinate[0]), //109.7039 经度，浮点数，范围为180 ~ -180。
        name: name, // 位置名
        address: address, // 地址详情说明
        scale: 20, // 地图缩放级别,整型值,范围从1~28。默认为最大
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      });
    })
  }
}
</script>
<style  lang="scss">
  .s-intro{
    background: rgba(0, 0, 0, 0.8);
    border-radius: 10rem;
    position: fixed;
    // width: calc(100vw - 15rem * 2);
    // bottom: 20rem;
    position: fixed;
    
    z-index: 10;
    left: 50%;
    top: 45%;
    width: 60%;    
    margin-left: -30%;
    // margin-left: 15rem;
    display: flex;
    height: 120rem;
    animation: backInUp 1s;
    &.clickclose{
     animation: backOutDown 1s;
    }

    .close{
      position: absolute;
      color: var(--fontGray);
      font-size: 24rem;
      right: 10rem;
      top: 5rem;
      cursor: pointer;
    }
    .intro-pic{
      height: 120rem;
      width: 120rem;
      border-radius: 10rem;
      overflow: hidden;
      margin-right: 15rem;
      position: relative;
      .s-audioLine{
        position: absolute;
        bottom: 0;
        left: 0;
      }
      .audioAni{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        z-index: 4;
      }
      .clock-total {
        position: absolute;
        left: 0;
        top: 0;
        padding: 5rem;
        border-radius: 10rem 0 10rem 0;
        background: rgba(0, 0, 0, 0.3);
        font-size: 10rem;
        color: #fff;
        z-index: 1;
      }
    }
  }
  .intro-txt{
      padding: 17rem 7rem 14rem 0;
      width: calc(100% - 120rem - 25rem);
      .title{
        font-size: 18rem;
        color: #fff;
        display: inline-block;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .sub{
        display: flex;
        align-items: center;
        margin-top: 10rem;
        color: #ABACAE;
        span {
          // white-space: nowrap;
          // overflow: hidden;
          // text-overflow: ellipsis;

          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: -o-ellipsis-lastline;
          text-overflow: ellipsis;
        }  
      }
      .intro-fun{
        display: flex;
        align-items: center;
        margin-top: 13rem;
        .fun-item{
          width: 70rem;
          // padding: 0 10rem;
          height: 26rem;
          border-radius: 20rem;
          border:1px solid var(--mainColor);
          color: var(--mainColor);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-right: 10rem;
          font-size: 14rem;
          white-space: nowrap;
          cursor: pointer;
          &:last-child{
            margin-right: 0;
          }
          &.active{
            background: var(--mainColor);
            color: #fff;
          }
        }
      }
      .more{
        margin-left: auto;
        color: #fff;
        display: flex;
        align-items: center;
        cursor: pointer;
        background: linear-gradient(95.3deg, #fd8539 0%, #ff6200 100%);
        border-radius: 10rem;
        padding: 0 5rem;
        .ico{
          width: 18rem;
          height: 18rem;
          position: relative;
          // top: 2rem;
          // margin-top: -3rem;
        }
        span{
          line-height: 20rem;
        }
      }
      .audio-progress{
        margin-top: 15rem;
        color: #ABACAE;
        
      }
    }

</style>